import { getCurrentScope, onScopeDispose, toValue, type MaybeRefOrGetter } from 'vue';

/**
 * Anything a composable can observe: an element, a template ref to one (or to
 * a component, whose root element is taken), or a getter returning one.
 */
export type NxMaybeElement = MaybeRefOrGetter<Element | { $el?: unknown } | null | undefined>;

/** The DOM element behind a {@link NxMaybeElement}, or `null`. */
export function unrefElement(target: NxMaybeElement): Element | null {
  const value = toValue(target);
  if (!value) return null;
  if (typeof Element !== 'undefined' && value instanceof Element) return value;
  const root = (value as { $el?: unknown }).$el;
  return typeof Element !== 'undefined' && root instanceof Element ? root : null;
}

/** Runs `fn` when the surrounding effect scope (component, effectScope) ends. */
export function onDispose(fn: () => void): void {
  if (getCurrentScope()) onScopeDispose(fn);
}
